module.exports = __webpack_public_path__ + "static/media/logo-white.5890cb09.png";